import React from "react";
import PropTypes from "prop-types";
import { Container, TitleContainer, Title, Subtitle, FailedResult } from "../styled";
import { Layout } from "../../v2/Layout";

export const FailedStatus = ({ financeType }) => {
  return (
    <Layout
      style={{
        mt: {
          xs: 1,
          sm: 7.5
        },
        mb: {
          xs: 22.5,
          sm: 10
        }
      }}
    >
      <Container>
        <TitleContainer>
          <Title>Thank you for your interest in RAKBANK {financeType} Finance.</Title>
          <FailedResult>
            <Subtitle>
              We will review your application and one of our representatives will contact you within
              2 working days to assist you further.
            </Subtitle>
            <Subtitle>Assuring you of our best services at all times.</Subtitle>
          </FailedResult>
        </TitleContainer>
      </Container>
    </Layout>
  );
};

FailedStatus.propTypes = {
  financeType: PropTypes.string.isRequired
};
